import _ from 'lodash'

class DetailController {
    constructor($stateParams, LanguageFactory, ModelFactory, Resource) {
        'ngInject'
        let vm = this
        vm.language = 'IT'
        vm.setLanguage = setLanguage
        vm.item = {}
        vm.section = 'description'
        vm.model = '';
        vm.isNew = true;
        vm.$onInit = init
        vm.init = init
        vm.getDetail = getDetail
        vm.createNew = createNew;

        function init() {
            if (!_.has($stateParams, 'id') || !_.has($stateParams, 'modelType')) {
                throw 'incomplete parameters for detail.controller.js'
            }

            vm.modelName = $stateParams.modelName;
            vm.modelEnum = vm.modelName.toUpperCase();

            if ($stateParams.id === "new") {
                vm.isNew = true;
                createNew(vm.modelName);
            }
            else {
                vm.isNew = false;
                vm.getDetail($stateParams.id, vm.modelName)
            }
        }

        function createNew(modelName) {
            let modelStructure = _.result(ModelFactory, 'get' + _.upperFirst(vm.modelName) + 'Structure');
            vm.item = {};
            vm.item[modelName] = {};
            vm.item[`${modelName}StringsList`] = [];
            let lang = {};

            // Ricostruisci l'oggetto secondo il modello sul backend, incluse
            // le strings list.
            _.each(modelStructure.model, (value, key) => {
                // proprietà di strings list
                if (value.prefix === 'lang') {
                    lang[key] = "";
                }
                // proprietà diretta della risorsa
                else if (value.prefix.indexOf("vm.") > -1) {
                    vm.item[modelName][key] = "";
                }
            })

            // Aggiungi tutte le lingue nella strings list
            _.each(LanguageFactory.getAvailableLanguageKeys(), l => {
                let langClone = _.clone(lang);
                langClone.language = l;
                vm.item[`${modelName}StringsList`].push(langClone);
            });
        }

        function getDetail(id, modelName) {
            Resource.get(modelName, id).then(res => {
                let langs = []
                let defaultLanguage = _.find(_.get(res.data, modelName + 'StringsList'),
                    {language: LanguageFactory.getDefaultLanguage()})

                console.log("Default language:", defaultLanguage);

                // Aggiungi le lingue mancanti clonando l'italiano,
                // assumendo l'italiano come sempre presente per costruzione.
                _.each(LanguageFactory.getAvailableLanguageKeys(), lang => {
                    let elem = _.find(_.get(res.data, modelName + 'StringsList'), {language: lang})
                    let newElem = {}
                    if (!elem && lang !== LanguageFactory.getDefaultLanguage()) {
                        newElem = _.clone(defaultLanguage)
                        newElem.language = lang //override della lingua di default
                        delete newElem.id //non salvare l'id!
                        langs.push(newElem)
                    }
                    else {
                        langs.push(elem)
                    }
                })
                res.data[modelName + 'StringsList'] = langs; //result: res.data.floraStringsList = langs
                console.log('Resource details:', res.data)
                vm.item = res.data
            })
        }

        function setLanguage(language) {
            vm.language = language
            // $stateParams.language = vm.language;
        }
    }
}

export default DetailController



// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/detail.controller.js